<template>
  <div style="padding: 20px">
    <div>
      <el-button type="primary" @click.stop="addBrand">配置品牌</el-button>
    </div>
    <el-table class="myTable" :data="tableData">
      <el-table-column
        prop="name"
        label="描述"
        min-width="120"
      ></el-table-column>
      <el-table-column prop="brandNames" label="品牌" min-width="120">
      </el-table-column>
      <el-table-column prop="operator" label="操作人"></el-table-column>
      <el-table-column label="操作" width="330" prop="">
        <template slot-scope="scope">
          <el-button type="text" @click="editBrand(scope.row)">编辑</el-button>
          <el-button type="text" @click="remveBrand(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right; margin: 20px 0; padding-bottom: 20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[15, 25, 30, 50]"
      :page-size="pageSize"
      layout="total, prev, pager, next,sizes, jumper"
      :total="total"
    ></el-pagination>
    <el-dialog
      :title="oprType == 'add' ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div style="width: 96%; margin: 0 auto">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          :rules="rules"
          label-width="100px"
          label-position="left"
          class="demo-ruleForm"
        >
          <el-form-item label="品牌：" prop="brandIds">
            <BrandSelect
              :data="brandList"
              v-model="ruleForm.brandIds"
              multiple
              filterable
              clearable
            ></BrandSelect>
          </el-form-item>
          <el-form-item label="描述：" prop="name">
            <el-input v-model="ruleForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="展示弹框：" prop="showSalePopup">
            <el-radio-group v-model="ruleForm.showSalePopup" @change="handlePopupSwitch">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.showSalePopup" label="弹框内容：" prop="salePopupContent">
            <el-input
              v-model="ruleForm.salePopupContent"
              type="textarea"
              :rows="5"
              maxlength="50"
              show-word-limit
              placeholder="请输入出售页弹框内容"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/utils/util";
import { downloadFile } from "@/utils/functions";
import {
  getSellerNoReasonAfterSaleConfigBrandList,
  saveSellerNoReasonAfterSaleConfigBrand,
  updateSellerNoReasonAfterSaleConfigBrand,
  removeSellerNoReasonAfterSaleConfigBrand,
  getSupplyPriceRuleList,
  downloadFileUrl,
  getSupplyPriceRuleDetail,
  saveSupplyPriceRule,
  invalidSupplyPriceRule,
  appendSku,
  getSkuFileList,
} from "../api.js";
import {
  fileUpload,
  getBrandList,
  category,
  seasonList,
} from "@/api/merchants";
import Client from "@/utils/client.js";

import BrandSelect from "@/views/components/brandSelect.vue";

export default {
  data() {
    var validator = (rule, value, callback) => {
      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error("仅允许输入20—99的整数数字，请修改"));
      } else if (Number(value) < 20 || Number(value) > 99) {
        callback(new Error("仅允许输入20—99的整数数字，请修改"));
      } else {
        callback();
      }
    };

    return {
      vendorList: [],
      cities: [],
      activityName: "",
      currentPage: 1,
      pageSize: 15,
      total: 0,
      ruleForm: {},
      rules: {
        brandIds: [
          { required: true, message: "请选择品牌。", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入描述", trigger: "blur" }],
        showSalePopup: [
          { required: true, message: "请选择是否展示弹框", trigger: "change" },
        ],
        salePopupContent: [
          {
            validator: (rule, value, callback) => {
              if (this.ruleForm.showSalePopup && !String(value || "").trim()) {
                callback(new Error("请输入弹框内容"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      dialogVisible: false,
      tableData: [],
      brandList: [],
      brandNameList: [],
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true,
      },
    };
  },
  components: { BrandSelect },
  created() {},
  async mounted() {
    await this.getBrands();
    this.query();
  },
  methods: {
    async getBrands() {
      let res = await getBrandList();
      this.brandList = (res.data || []).map((item) => ({
        label: item.englishName,
        value: item.brandId,
      }));
      this.brandNameList = (res.data || []).map((item) => ({
        label: item.englishName,
        value: item.englishName,
      }));
    },
    query() {
      this.currentPage = 1;
      this.getTableData();
    },
    handleClose() {
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
    },
    async getTableData() {
      let targetObj = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      this.$store.commit("setPageLoading", true);
      let res = await getSellerNoReasonAfterSaleConfigBrandList(targetObj);
      this.$store.commit("setPageLoading", false);
      if (res.success && res.data) {
        let { total, list } = res.data;
        this.total = total;
        this.tableData = (list || []).map(item => {
          return {
            ...item,
            brandNames: item.brandIds && item.brandIds.length ? this.brandList.filter(it => item.brandIds.includes(it.value)).map(it => it.label).join('、') : ""
          }
        });
      } else {
        this.$message.error(`${resData.message}`);
        return;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    addBrand() {
      this.ruleForm = {
        brandIds: [],
        name: "",
        showSalePopup: false,
        salePopupContent: "",
      };
      this.oprType = "add";
      this.dialogVisible = true;
    },
    editBrand(row) {
      this.ruleForm = {
        configId: row.configId,
        brandIds: [],
        name: row.name,
        showSalePopup: row.showSalePopup === true || row.showSalePopup === 1,
        salePopupContent: row.salePopupContent || "",
      };
      this.oprType = "edit";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.ruleForm.brandIds = row.brandIds;
      });
    },
    submitDialog() {
      if (!this.ruleForm.showSalePopup) {
        this.ruleForm.salePopupContent = "";
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        let action =
          this.oprType == "add"
            ? saveSellerNoReasonAfterSaleConfigBrand
            : updateSellerNoReasonAfterSaleConfigBrand;
        this.$store.commit("setPageLoading", true);
        action(this.ruleForm).then((res) => {
          this.$store.commit("setPageLoading", false);
          if (res.success) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
            this.getTableData();
          } else {
            this.$message.error(res.message || "操作失败");
          }
        });
      });
    },
    handlePopupSwitch(value) {
      if (!value) {
        this.$nextTick(() => this.$refs.ruleForm && this.$refs.ruleForm.clearValidate("salePopupContent"));
      }
    },
    remveBrand(row) {
      this.$confirm(`确认删除当前数据?`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.commit("setPageLoading", true);
          removeSellerNoReasonAfterSaleConfigBrand({
            configId: row.configId,
          }).then((res) => {
            this.$store.commit("setPageLoading", false);
            if (res.success) {
              this.$message.success("操作成功");
              this.getTableData();
            } else {
              this.$message.error(res.message || "操作失败");
            }
          });
        })
        .catch(() => {
          this.$store.commit("setPageLoading", false);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.dialogContainer .el-checkbox {
  margin-left: 0;
  margin-right: 20px;
  margin-bottom: 5px;
}
.manipulate {
  margin-right: 12px;
  color: #409eff;
  cursor: pointer;
}
.dot {
  display: inline-block;
  margin-right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.gray {
  background: #cccccc;
}
.green {
  background: green;
}
.dropdown-item {
  margin: 0;
  padding: 7px 16px;
  clear: both;
  color: #657180;
  font-size: 12px !important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.demo-ruleForm {
  margin: 20px 0px;
}
.flex {
  height: 80px;
  padding-top: 13px;
  padding-left: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}
.absolute {
  position: absolute;
  top: 0;
  left: 168px;
}
.upload-wrap {
  position: relative;
  display: inline-block;
  margin-left: 10px;

  input {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 10;
  }
}
</style>
